export const addresses = {
  font:"0xbFde916e6315365567F3504E20166F92474dc4ea",
}
